import { render } from "./altainventario.vue?vue&type=template&id=da7fc40c&scoped=true"
import script from "./altainventario.vue?vue&type=script&lang=js"
export * from "./altainventario.vue?vue&type=script&lang=js"

import "./altainventario.vue?vue&type=style&index=0&id=da7fc40c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da7fc40c"]])

export default __exports__